// IMPORTANTE: Substitua estes links pelos seus links reais do Mercado Pago
const LINKS_MERCADO_PAGO = {
  basic: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=9e22c75ee6604bc7b5df2a494f798294",
  creator: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=8035d9aa69234cef8ff26d12bdb7f5ed",
  elite: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=aa5f9cac813c4706bd8a8d3a84485949",
};

function PricingCard({ title, price, description, features, highlight, link, isTrial }) {

  return (
    <div
      className={`border rounded-2xl p-6 md:p-8 shadow-sm flex flex-col gap-4 transition-all hover:shadow-lg ${highlight ? "border-blue-600 shadow-md" : "border-gray-200"
        } bg-white`}
    >
      {highlight && (
        <span className="inline-block text-xs font-semibold text-white bg-blue-600 px-3 py-1 rounded-full self-start">
          Mais recomendado
        </span>
      )}

      <h3 className="text-xl font-bold text-gray-900">{title}</h3>
      <p className="text-3xl font-extrabold text-gray-900">
        {price}
        <span className="text-base font-normal text-gray-500"> /mês</span>
      </p>
      <p className="text-sm text-gray-600">{description}</p>

      <ul className="mt-4 space-y-2 text-sm text-gray-700">
        {features.map((feat, idx) => (
          <li key={idx} className="flex items-start gap-2">
            <span className="mt-1 text-blue-600">✔</span>
            <span>{feat}</span>
          </li>
        ))}
      </ul>

      <a
        href={isTrial ? "https://app.gerador.codertec.com.br" : link}
        target={isTrial ? "_self" : "_blank"}
        rel="noopener noreferrer"
        className={`block text-center w-full py-2.5 rounded-lg text-sm font-semibold transition
    ${isTrial
            ? "bg-blue-600 text-white hover:bg-blue-700"
            : "border border-blue-600 text-blue-600 hover:bg-blue-50"
          }`}
      >
        {isTrial ? "Testar grátis por 7 dias" : "Assinar agora"}
      </a>


    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* Header */}
      <header className="border-b bg-white sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white text-lg font-bold">
              IA
            </div>
            <span className="font-semibold text-gray-900">
              Gerador de Conteúdo Pro
            </span>
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm">
            <a href="#como-funciona" className="hover:text-blue-600 transition">
              Como funciona
            </a>
            <a href="#planos" className="hover:text-blue-600 transition">
              Planos
            </a>
            <a href="#faq" className="hover:text-blue-600 transition">
              Dúvidas
            </a>
          </nav>
          <a
            href="#planos"
            className="hidden md:inline-block text-sm font-semibold px-4 py-2 rounded-lg border border-blue-600 text-blue-600 hover:bg-blue-50 transition"
          >
            Ver planos
          </a>
        </div>
      </header>

      {/* Hero */}
      <main className="max-w-6xl mx-auto px-4 py-10 md:py-16">
        <section className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight mb-4">
              Gere posts, roteiros de Reels e ideias de conteúdo com IA em
              poucos segundos.
            </h1>
            <p className="text-gray-600 text-sm md:text-base mb-6">
              Ferramenta pensada para social media, profissionais liberais e
              negócios locais que precisam postar com frequência, sem ficar
              horas escrevendo texto e roteiros.
            </p>

            <ul className="space-y-2 text-sm text-gray-700 mb-6">
              <li className="flex gap-2">
                <span className="mt-1 text-blue-600">✔</span>
                <span>Textos otimizados para Instagram, Facebook, LinkedIn e Blog.</span>
              </li>
              <li className="flex gap-2">
                <span className="mt-1 text-blue-600">✔</span>
                <span>Roteiro completo para Reels, Shorts e TikTok.</span>
              </li>
              <li className="flex gap-2">
                <span className="mt-1 text-blue-600">✔</span>
                <span>Sugestões de imagens, cenas e trilhas sonoras.</span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://app.gerador.codertec.com.br"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition"
              >
                Testar grátis por 7 dias
              </a>
              <a
                href="#como-funciona"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition"
              >
                Ver como funciona
              </a>
            </div>
            <p className="mt-3 text-xs text-gray-500">
              Teste grátis por 7 dias • Sem risco • Cancele quando quiser
            </p>
          </div>

          <div className="bg-white border rounded-2xl p-6 shadow-sm text-sm">
            <h2 className="text-base font-semibold mb-2">
              Exemplos do que você pode gerar:
            </h2>
            <ul className="space-y-2 text-gray-700">
              <li>
                • Série de posts semanais para{" "}
                <b>clínica de psicologia</b>: ansiedade, autocuidado, rotina
                saudável.
              </li>
              <li>
                • Roteiro de Reels para <b>dentista</b> mostrando antes/depois,
                bastidores e depoimentos.
              </li>
              <li>
                • Conteúdos educativos para{" "}
                <b>empresa de ar-condicionado</b>: manutenção preventiva, economia
                de energia, PMOC.
              </li>
            </ul>
          </div>
        </section>

        {/* Como funciona */}
        <section id="como-funciona" className="mt-16">
          <h2 className="text-2xl font-bold mb-4">Como funciona na prática</h2>
          <div className="grid md:grid-cols-3 gap-6 text-sm">
            <div className="bg-white border rounded-2xl p-5 shadow-sm hover:shadow-md transition">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mb-3">
                1
              </div>
              <h3 className="font-semibold mb-2">Informe o nicho e o tema</h3>
              <p className="text-gray-600">
                Escolha o tipo de negócio (clínica, consultório, loja, etc.) e o
                tema do conteúdo que deseja criar.
              </p>
            </div>
            <div className="bg-white border rounded-2xl p-5 shadow-sm hover:shadow-md transition">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mb-3">
                2
              </div>
              <h3 className="font-semibold mb-2">
                Selecione plataforma e estilo
              </h3>
              <p className="text-gray-600">
                Defina se será post estático (feed/blog) ou vídeo curto
                (Reels/Shorts/TikTok), além do tom, tamanho e público-alvo.
              </p>
            </div>
            <div className="bg-white border rounded-2xl p-5 shadow-sm hover:shadow-md transition">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mb-3">
                3
              </div>
              <h3 className="font-semibold mb-2">Gere e publique</h3>
              <p className="text-gray-600">
                A IA entrega texto, roteiro e sugestões de imagens/cenas.
                Ajuste detalhes, copie e cole nas suas redes.
              </p>
            </div>
          </div>
        </section>

        {/* Planos */}
        <section id="planos" className="mt-16">
          <h2 className="text-2xl font-bold mb-2">
            Planos pensados para quem vive de conteúdo
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Sem limite de textos. Você escolhe o plano pelas funcionalidades que precisa.
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            <PricingCard
              title="Basic"
              price="R$ 29"
              description="Para quem está começando a usar IA no dia a dia."
              features={[
                "Posts estáticos para Instagram, Facebook, LinkedIn e Blog",
                "Sugestão de hashtags e CTAs",
                "Textos otimizados para SEO",
                "Uso individual",
              ]}
              link={LINKS_MERCADO_PAGO.basic}
            />

            <PricingCard
              title="Creator"
              price="R$ 69"
              description="Perfeito para social media e profissionais liberais."
              features={[
                "Tudo do plano Basic",
                "Roteiro para Reels, Shorts e TikTok",
                "Sugestões de cenas e trilhas para vídeos",
                "Histórico dos últimos 30 dias (na ferramenta)",
              ]}
              highlight
              link={LINKS_MERCADO_PAGO.creator}
            />

            <PricingCard
              title="Elite"
              price="R$ 149"
              description="Para quem gerencia vários perfis ou clientes."
              features={[
                "Tudo do plano Creator",
                "Histórico ilimitado (na ferramenta)",
                "Organização por cliente/nicho",
                "Exportação de conteúdos (PDF/CSV)",
              ]}
              link={LINKS_MERCADO_PAGO.elite}
            />
          </div>

        </section>

        {/* FAQ */}
        <section id="faq" className="mt-16 mb-12">
          <h2 className="text-2xl font-bold mb-4">Perguntas frequentes</h2>
          <div className="space-y-4 text-sm text-gray-700">
            <div className="bg-white border rounded-xl p-5">
              <p className="font-semibold mb-2">
                • Posso usar para quantos nichos eu quiser?
              </p>
              <p className="text-gray-600">
                Sim. Você pode gerar conteúdo para quantos nichos e perfis desejar,
                respeitando as políticas das plataformas e da IA.
              </p>
            </div>
            <div className="bg-white border rounded-xl p-5">
              <p className="font-semibold mb-2">
                • O conteúdo é realmente único?
              </p>
              <p className="text-gray-600">
                Os textos são gerados sob demanda pela IA, com base nas suas
                instruções. Recomendamos sempre revisar e ajustar para a voz da
                sua marca.
              </p>
            </div>
            <div className="bg-white border rounded-xl p-5">
              <p className="font-semibold mb-2">
                • Como funciona o pagamento?
              </p>
              <p className="text-gray-600">
                O pagamento é feito via Mercado Pago, em ambiente seguro. Após a
                confirmação, você recebe as instruções de acesso ao painel da
                ferramenta.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Rodapé */}
      <footer className="border-t bg-white">
        <div className="max-w-6xl mx-auto px-4 py-4 text-xs text-gray-500 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>
            © {new Date().getFullYear()} Gerador de Conteúdo com IA. Todos os
            direitos reservados.
          </span>
          <span>Desenvolvido por CoderTec.</span>
        </div>
      </footer>
    </div>
  );
}